import { render, staticRenderFns } from "./CargoContent.vue?vue&type=template&id=bca4c6c4"
import script from "./CargoContent.vue?vue&type=script&lang=js"
export * from "./CargoContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports